import selector from 'utils/selector'
import Pager from 'utils/pager'
import {Problem} from 'data/types'
import services from 'services'
import APIService, {ProblemInput} from './APIService'

class ProblemService {
  private projectId: number
  private pager = new Pager<Problem>(50)

  public constructor(projectId: string) {
    this.projectId = parseInt(projectId, 10)
    this.connect()
    this.load()
  }

  public get problems() {
    return this.pager.items
  }

  public get hasMore() {
    return !this.pager.completed.value
  }

  private connect = () => {
    services
      .getDispatchService()
      .observe<Problem>('problemUpdated')
      .subscribe((problem) => {
        this.updateProblemInList(problem)
      })

    services
      .getDispatchService()
      .observe<Problem>('problemArchived')
      .subscribe((problem) => this.removeProblemFromList(problem))
  }

  public load = async () => {
    if (this.problems.isLoading) {
      return
    }
    this.problems.startLoading()
    await this.pager.load(async (page) => {
      const response = await APIService.getProblems({page, project_id: this.projectId})
      if (response.ok) {
        return response.body
      }
      return []
    })
    this.problems.endLoading()
  }

  public updateProblemInList = (problem: Problem) => {
    this.problems.reduce((items) =>
      items.map((pb) => {
        if (pb.id === problem.id) {
          return problem
        }
        return pb
      })
    )
  }

  public removeProblemFromList = (problem: Problem) => {
    this.problems.reduce((items) => items.filter((p) => p.id !== problem.id))
  }

  public createProblem = async (input: ProblemInput) => {
    const response = await APIService.createProblem(input)
    if (response.ok) {
      this.problems.reduce((pbs) => [response.body].concat(pbs))
    }
  }
}

type ProblemSelectorInput = {
  token: string
  projectId: string
}

const tokenSelector = (input: ProblemSelectorInput) => input.token
const projectIdSelector = (input: ProblemSelectorInput) => input.projectId

export const problemServiceSelector = selector(tokenSelector, projectIdSelector, (token, projectId) => new ProblemService(projectId))
